import { render, staticRenderFns } from "./CategoriaListAddNew.vue?vue&type=template&id=4b0d74ff&"
import script from "./CategoriaListAddNew.vue?vue&type=script&lang=js&"
export * from "./CategoriaListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./CategoriaListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports